<div fxLayout="row" [ngSwitch]="fileType">
  <div *ngSwitchCase="'image'" class="attachment__preview" [style.backgroundImage]="'url(' + thumbnail + ')'"></div>
  <div *ngSwitchCase="'video'" class="attachment__preview" [style.backgroundImage]="'url(' + thumbnail + ')'">
    <div class="attachment__preview--play-icon"></div>
  </div>
  <div *ngSwitchCase="'other'" class="attachment__no-image">
    <mat-icon>insert_drive_file</mat-icon>
  </div>
  <div fxLayout="column">
    <span class="attachment__title">
      {{ attachment.title || ('MAINTENANCES.TABS.ATTACHMENTS.NO_TITLE' | translate) }}
    </span>
    <span class="attachment__time">{{ attachment.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
    <a class="attachment__link" [href]="attachment.path" target="_blank"> Ver original </a>
  </div>
</div>
